import { MessageBar, MessageBarBody } from '@fluentui/react-components';
import React from 'react';

interface EvaluationModeBannerProps {
  show: boolean;
}

const EvaluationModeBannerImpl: React.FC<EvaluationModeBannerProps> = ({ show }) => {
  if (!show) {
    return null;
  }
  return (
    <MessageBar intent='info'>
      <MessageBarBody>
        Evaluation run - awards will not be modified. Results appear in the AI Eval tab.
      </MessageBarBody>
    </MessageBar>
  );
};

export const EvaluationModeBanner = EvaluationModeBannerImpl;
